import React from "react";
//PrimeReact Components
import * as pr from "../../../common/PrimeComponents";
import { CrudlStatus } from "../../../common/config/AppConstants";
import { BPMInput } from "../../Common/BPMInput";
import * as format from "../../../common/FormatFunctions";
import { ListValueGenerator } from "../../Common/ListValueGenerator";
import { LoadScreen } from "../../Common/LoadScreen";
import { FileUploader } from "../../Common/FileUploader";
import { FlowItemDisplay } from "./FlowItemDisplay";
import * as Storage from "../../../common/config/Storage";
import { BPMPartProductJson } from "../../Common/BPMPartProductJson";
import { FlowItemCard } from "./FlowItemCard";
export class FlowCard extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      currentFlowItem: {},
      originalCurrentFlowItem: {},
      flowItemCrudlState: CrudlStatus.CREATE,
      showSidebar: false
    };
  }

  reorderSequence = e => {
    console.log(e);
    this.props.updateValue("flowItemList", e.value);
  };

  updateCurrentFlowFiles = files => {
    this.props.updateValue("fileUrls", files);
  };

  updateCurrentFlowItem = (field, value) => {
    var bean = this.state.currentFlowItem;
    bean[field] = value;

    this.setState({ currentFlowItem: bean });
  };

  deleteFlowItem = () => {
    var flowItem = format.deepCopy(this.state.currentFlowItem);
    if (format.isNotNull(this.props.editedObject.flowItemList)) {
      var localFlowItemList = format.deepCopy(
        this.props.editedObject.flowItemList
      );
      var parsedLocalFlowItemList = [];

      if (format.isNotNull(localFlowItemList)) {
        localFlowItemList.forEach(element => {
          if (element.id === flowItem.id) {
          } else {
            parsedLocalFlowItemList.push(element);
          }
        });
      }

      this.props.updateValue("flowItemList", parsedLocalFlowItemList);
      this.closeFlowItem();
    }
  };
  updateFlowItem = () => {
    var flowItem = format.deepCopy(this.state.currentFlowItem);

    if (this.state.flowItemCrudlState === CrudlStatus.CREATE) {
      var localFlowItemList = [];
      if (format.isNotNull(this.props.editedObject.flowItemList)) {
        localFlowItemList = format.deepCopy(
          this.props.editedObject.flowItemList
        );
      }

      localFlowItemList.push(flowItem);

      this.props.updateValue("flowItemList", localFlowItemList);
      this.closeFlowItem();
    } else {
      var localFlowItemList = [];
      if (format.isNotNull(this.props.editedObject.flowItemList)) {
        localFlowItemList = format.deepCopy(
          this.props.editedObject.flowItemList
        );
      }
      var parsedLocalFlowItemList = [];

      if (format.isNotNull(localFlowItemList)) {
        localFlowItemList.forEach(element => {
          if (element.id === flowItem.id) {
            console.log(flowItem);
            parsedLocalFlowItemList.push(flowItem);
          } else {
            parsedLocalFlowItemList.push(element);
          }
        });
      }

      this.props.updateValue("flowItemList", parsedLocalFlowItemList);
      this.closeFlowItem();
    }
  };

  closeFlowItem = () => {
    this.setState({
      showSidebar: false,
      currentFlowItem: {},
      flowItemCrudlState: CrudlStatus.LIST
    });
  };

  selectFlowItem = (crudlStatus, data) => {
    if (crudlStatus === CrudlStatus.UPDATE) {
      this.setState({
        currentFlowItem: format.deepCopy(data),
        flowItemCrudlState: CrudlStatus.UPDATE,
        showSidebar: true
      });
    } else {
      const min = 1;
      const max = 100;
      const rand = min + Math.random() * (max - min);

      this.setState({
        currentFlowItem: { id: rand },
        flowItemCrudlState: CrudlStatus.CREATE,
        showSidebar: true
      });
    }
  };
  render() {
    var sequence = 1;
    if (format.isNotNull(this.props.editedObject)) {
      if (format.isNotNull(this.props.editedObject.flowItemList)) {
        this.props.editedObject.flowItemList.forEach(e => {
          e.sequence = sequence.toString();
          sequence++;
        });
      }
    }
    return (
      <React.Fragment>
        <pr.ScrollPanel
          ref={el => (this.layoutMenuScroller = el)}
          style={{ height: "85%", borderColor: "transparent" }}
        >
          <div className="ui-g">
            <div className="ui-g-12"></div>
            {this.props.loading === true && <LoadScreen />}
            {this.props.loading !== true && (
              <React.Fragment>
                <div className="ui-g-1"></div>
                <div className="ui-g-10">
                  {"Fill out these details and reuse flows across multiple " +
                    this.props.typeDisplay}

                  {/* <pr.Button
                    type="button"
                    icon="pi pi-plus"
                    label="Copy Flow"
                    className="p-button-success"
                    onClick={e => {}}
                    style={{ marginRight: ".5em", float: "right" }}
                  ></pr.Button> */}
                </div>
                <div className="ui-g-1"></div>
                <div className="ui-g-1"></div>
                <div className="ui-g-5">
                  <div className="ui-g-12">
                    <div className="ui-g-3">
                      <label className="input-label">Name *</label>
                    </div>

                    <div className="ui-g-9">
                      <pr.InputText
                        required={true}
                        value={this.props.editedObject.name}
                        onChange={e =>
                          this.props.updateValue("name", e.target.value)
                        }
                        disabled={this.props.crudlState === CrudlStatus.VIEW}
                      />
                    </div>
                  </div>
                  <div className="ui-g-12">
                    <div className="ui-g-3">
                      <label className="input-label">Description *</label>
                    </div>

                    <div className="ui-g-9">
                      <pr.InputText
                        required={true}
                        value={this.props.editedObject.description}
                        onChange={e =>
                          this.props.updateValue("description", e.target.value)
                        }
                        disabled={this.props.crudlState === CrudlStatus.VIEW}
                      />
                    </div>
                  </div>
                  <div className="ui-g-12">
                    <div className="ui-g-3">
                      <label className="input-label">Notes</label>
                    </div>

                    <div className="ui-g-9">
                      <textarea
                        id={this.props.editedObject.notes + " Details"}
                        rows={5}
                        placeholder=""
                        value={this.props.editedObject.notes}
                        onChange={e => {
                          this.props.updateValue("notes", e.target.value);
                        }}
                        disabled={this.props.crudlState === CrudlStatus.VIEW}
                        style={{
                          width: "100%",
                          backgroundColor: "transparent"
                        }}
                      />
                    </div>
                  </div>
                </div>
                <div className="ui-g-5">
                  <div className="ui-g-12">
                    <label className="input-label">
                      {"Upload Standard Operating Procedures(SOP's) to produce this " +
                        this.props.typeDisplay}
                    </label>
                    <FileUploader
                      fileType="FILE"
                      header={"SOP's"}
                      emptyTableDisplay={"No SOP’s uploaded"}
                      label="Upload"
                      accept=".doc,.pdf,.docx,.xls"
                      currentFiles={this.props.editedObject.fileUrls}
                      updateFiles={this.props.updateValue}
                      field={"fileUrls"}
                    />
                  </div>
                </div>

                <div className="ui-g-1"></div>
                <div className="ui-g-1"></div>
                <div className="ui-g-10">
                  <pr.DataTable
                    value={this.props.editedObject.flowItemList}
                    selectionMode="single"
                    onSelectionChange={e => {
                      this.selectFlowItem(CrudlStatus.UPDATE, e.data);
                    }}
                    header={
                      <div className="ui-g">
                        <div className="ui-g-4"></div>
                        <div className="ui-g-4">
                          <label className="header-label">
                            Operations/Routings
                          </label>
                        </div>
                        <div className="ui-g-4">
                          <pr.Button
                            type="button"
                            icon="pi pi-plus"
                            label="Add Flow Item"
                            className="p-button-success"
                            onClick={e => {
                              this.selectFlowItem(CrudlStatus.CREATE);
                            }}
                            style={{ marginRight: ".5em", float: "right" }}
                          ></pr.Button>
                        </div>
                      </div>
                    }
                    emptyMessage="No Operations or Routings available"
                    expandedRows={this.state.expandedRows}
                    onRowToggle={e => this.setState({ expandedRows: e.data })}
                    rowExpansionTemplate={this.getSelectionView}
                    autoLayout={true}
                    paginator={false}
                    alwaysShowPaginator={false}
                    reorderableRows={true}
                    onRowReorder={e => this.reorderSequence(e)}
                  >
                    <pr.Column
                      rowReorder={true}
                      rowReorderIcon="pi pi-list"
                      style={{
                        width: "3em",
                        float: "middle",
                        cursor: "move"
                      }}
                    />

                    <pr.Column
                      field="name"
                      header="Name"
                      sortable={true}
                      filter={true}
                      style={{ overflow: "auto" }}
                    />

                    <pr.Column
                      field="sequence"
                      header="Sequence"
                      sortable={true}
                      filter={true}
                      style={{ overflow: "auto" }}
                    />
                  </pr.DataTable>
                </div>

                <div className="ui-g-1"></div>
                <div className="ui-g-1"></div>
                <div className="ui-g-5">
                  <pr.Sidebar
                    visible={this.state.showSidebar}
                    fullScreen={true}
                    onHide={e => {
                      this.closeFlowItem();
                    }}
                  >
                    <FlowItemCard
                      type={this.props.type}
                      editedObject={this.state.currentFlowItem}
                      updateValue={this.updateCurrentFlowItem}
                      closeFlowItem={this.closeFlowItem}
                      crudlControl={this.flowItemCrudlControl}
                      crudlState={this.state.flowItemCrudlState}
                      crudlExecute={this.flowItemCrudlExecute}
                      stationMap={this.props.stationMap}
                      componentList={this.props.componentList}
                      saveFlowItem={this.updateFlowItem}
                      deleteFlowItem={this.deleteFlowItem}
                    />
                  </pr.Sidebar>
                </div>
              </React.Fragment>
            )}
          </div>
        </pr.ScrollPanel>
      </React.Fragment>
    );
  }

  getSelectionView = bean => {
    return <FlowItemDisplay data={bean} />;
  };

  attributeListToFields = () => {
    let componentArray = [];
    let i = 0;
    console.log(this.props.selectedAttributeSet);
    if (this.props.selectedAttributeSet !== undefined) {
      if (this.props.selectedAttributeSet.attributeBeanList !== undefined) {
        this.props.selectedAttributeSet.attributeBeanList.forEach(e => {
          if (e.type === "LIST") {
            componentArray[i] = (
              <div className="ui-g-12" key={i}>
                <div className="ui-g-3">
                  <label className="input-label">{e.name}</label>
                </div>
                <div className="ui-g-9">
                  <pr.Dropdown
                    value={
                      JSON.parse(this.props.editedObject.customPropertiesJson)[
                        e.name
                      ] || ""
                    }
                    options={pr.getDropdownOptionsFromList(e.acceptedValues)}
                    onChange={f => {
                      this.props.updateAttributeProperties(e.name, f.value);
                    }}
                    filter={true}
                    filterBy="label"
                    filterPlaceholder="Search"
                    style={{ width: "100%" }}
                  />
                </div>
                {/* <div className="ui-g-12 ui-md-4" style={{ paddingTop: "2em" }}>
                
                  {this.props.editedObject.operationalType === "CONFIGURABLE" && (
                    <div className="p-col-12">
                      <pr.Checkbox
                        inputId="cb1"
                        checked={this.state.attributeConfigurable[e.name]}
                        onChange={f => {
                          this.updateConfigList(e.name, f.checked);
                        }}
                      />
                      <label htmlFor="cb1" className="p-checkbox-label">
                        Configurable?
                      </label>
                    </div>
                  )}
                  {this.props.editedObject.operationalType === "VARIABLE" && (
                    <div className="p-col-12">
                      <pr.Checkbox
                        inputId="cb1"
                        checked={this.state.attributeVariable[e.name].checked}
                        onChange={f => {
                          this.updateVariableList(e.name, f.checked);
                        }}
                      />
                      <label htmlFor="cb1" className="p-checkbox-label">
                        Variable?
                      </label>
                    </div>
                  )}
                </div> */}
              </div>
            );
          }

          if (e.type === "INPUT") {
            componentArray[i] = (
              <div className="ui-g-12" key={i}>
                <div className="ui-g-3">
                  <label className="input-label">{e.name}</label>
                </div>
                <div className="ui-g-9">
                  <pr.InputText
                    id={e.name + " Attribute"}
                    value={
                      JSON.parse(this.props.editedObject.customPropertiesJson)[
                        e.name
                      ] || ""
                    }
                    onChange={f => {
                      this.props.updateAttributeProperties(
                        e.name,
                        f.target.value
                      );
                    }}
                  />
                </div>
                {/* <div className="ui-g-12 ui-md-4" style={{ paddingTop: "2em" }}>
                  <b>{e.unitOfMeasurement || ""}</b>
                </div> */}
                {/* <div className="ui-g-12 ui-md-4" style={{ paddingTop: "2em" }}>
        
                  {s.editedPart.operationalType === "CONFIGURABLE" && (
                    <div className="p-col-12">
                      <pr.Checkbox
                        inputId="cb1"
                        checked={this.state.attributeConfigurable[e.name]}
                        onChange={f => {
                          this.updateConfigList(e.name, f.checked);
                        }}
                      />
                      <label htmlFor="cb1" className="p-checkbox-label">
                        Configurable?
                      </label>
                    </div>
                  )}
                  {s.editedPart.operationalType === "VARIABLE" && (
                    <div className="p-col-12">
                      <pr.Checkbox
                        inputId="cb1"
                        checked={this.state.attributeVariable[e.name].checked}
                        onChange={f => {
                          this.updateVariableList(e.name, f.checked);
                        }}
                      />
                      <label htmlFor="cb1" className="p-checkbox-label">
                        Variable?
                      </label>

                      {this.state.attributeVariable[e.name] && (
                        <div className="ui-g-12">
                          {this.getAcceptedValues(e.name)}
                        </div>
                      )}
                    </div>
                  )}
                </div> */}
              </div>
            );
          }

          i++;
        });
      }
    }

    return componentArray;
  };
}



// WEBPACK FOOTER //
// ./src/components/Flows/UI/FlowCard.js